



import {Component, Vue} from 'vue-property-decorator';

import StepCardInfo from "@/components/Organisms/StepCardInfo/StepCardInfo.vue";
import StepCardInfoContent from "@/components/Molecules/StepCardInfoContent/StepCardInfoContent.vue";
import CardSetting from "@/components/Molecules/CardSetting/CardSetting.vue";
import SvgRender from "@/components/Atoms/SvgRender/SvgRender.vue";
import SelectBaby from "@/components/Molecules/SelectBaby/SelectBaby.vue";
import MemoModalContainer from "@/components/Organisms/MemoModalContainer/MemoModalContainer.vue";
import ButtonSuccessful from "@/components/Atoms/ButtonSuccessful/ButtonSuccessful.vue";
import ButtonOutlineSuccessful from "@/components/Atoms/ButtonOutlineSuccessful/ButtonOutlineSuccessful.vue";
import StepFullName from "@/components/Molecules/StepFullName/StepFullName.vue";
import * as confetti from 'canvas-confetti';
import {BABY, GROW_TREE_MODAL_TYPE, TYPE_MEMO, UPLOAD_MAX_SIZE} from "@/constants";
import {eventBusService, ServiceFactory} from "@/services";
import {BabyFilter, BabyHomeModel, EventBusUploadModalType, MilestoneClearModel, MilestoneDto} from "@/share";
import Categories from "@/constants/category";
import {
  CategoryHomeInterface,
  MilestoneInterface,
  MilestoneMemoInterface
} from "@/share/types/interface";
import i18n from "@/langs/i18n";

const CategoryService = ServiceFactory.get('category');
const BabyService = ServiceFactory.get('baby');
const UPLOAD = {
  MEDAL: {
    STEP: require('@/assets/images/step-done-medal.png'),
    MILESTONE: require('@/assets/images/milestone-done-medal.png')
  },
  BACKGROUND: {
    STEP: require('@/assets/images/bg-step-done.png'),
    MILESTONE: require('@/assets/images/bg-milestone-done.png')
  }
}

const MEMO_SRC = {
  MILESTONE: require('@/assets/images/milestone-memo.png'),
  STEP: require('@/assets/images/point-memo.png')
}

@Component({
  components: {
    StepCardInfo,
    StepCardInfoContent,
    CardSetting,
    SvgRender,
    SelectBaby,
    MemoModalContainer,
    ButtonSuccessful,
    ButtonOutlineSuccessful,
    StepFullName
  }
})
export default class Home extends Vue {
  private isLoading = false
  private isUploadFileLoading = false
  private isGetCategoryLoading = false

  private isOpen = false
  private imageFile: any = ''
  private imageFileUrl: any = ''

  private modelMilestoneMemo = false
  private modalVisible = false
  private modalConfirm = false
  private modelMemo = false
  private memos: MilestoneClearModel[] = []
  private memo = ''
  private memoSrc = ''
  private type = 0;
  private congratulationText = ''
  private categories: CategoryHomeInterface[] = []
  private milestonesMemo: MilestoneMemoInterface[] = []
  private milestoneMemo = ''
  private babies: BabyHomeModel[] = []
  private babySelected: BabyHomeModel = new BabyHomeModel({})
  private milestoneType = GROW_TREE_MODAL_TYPE
  private milestone: any = {}
  private babyId = ''
  private errorFile = ''
  private isLoadingUpload = false
  private hasOverlay = true
  private data = []
  private cardData = []

  private get isPageLoading(): boolean {
    return this.isLoading || this.isGetCategoryLoading;
  }

  private get loadingClass(): string {
    if (this.isPageLoading) return 'invisible'
    return ''
  }

  private get uploadBackground(): string {
    if (this.type == this.milestoneType.MILESTONE) return UPLOAD.BACKGROUND.MILESTONE
    return UPLOAD.BACKGROUND.STEP
  }

  private get uploadMedal(): string {
    if (this.type == this.milestoneType.MILESTONE) return UPLOAD.MEDAL.MILESTONE
    return UPLOAD.MEDAL.STEP
  }

  async created(): Promise<void> {
    this.isLoading = true
    await this.getBabies()
    await this.getCategories()
    this.isLoading = false

    eventBusService.$on(
      eventBusService.EVENT_SHOW_UPLOAD_MODAL,
      (data: EventBusUploadModalType) => this.showConfirmModal(data)
    )
  }

  private mounted() {
    // this.hasOverlay = false
  }

  private async getBabies(): Promise<void> {
    this.babies = await BabyService.list().catch(() => [])
    const babyId = localStorage.getItem(BABY.SELECTED);

    if (!this.babies || !this.babies.length) return

    const baby = this.babies.find(o => o.id.toString() == babyId)
    if (baby && babyId) {
      this.babyId = babyId
      this.babySelected = baby
      return
    }

    this.babySelected = this.babies[0]
    this.babyId = this.babySelected.id.toString()
    localStorage.setItem(BABY.SELECTED, this.babyId);
  }

  private onchangeBaby(baby: BabyHomeModel): void {
    this.babySelected = baby
    this.babyId = this.babySelected.id.toString()
    localStorage.setItem(BABY.SELECTED, baby.id.toString());
    this.getCategories()
  }

  private get isVerify(): any {
    return (id: number) => id == this.babySelected.id
  }

  private get babyAvatar(): string {
    if (this.babySelected.avatar) return this.babySelected.avatar
    return require('@/assets/images/default-avatar.png')
  }

  private getCategory(type: number): any {
    const category = Categories.find(o => o.key === type)
    return category ? category : Categories[0]
  }

  private getCardData(categories: any): any {
    let data: any = []
    categories.map((item: any) => {
      const category = this.getCategory(item.type)
      item.milestones.map((milestone: any) => {
        milestone.categoryType = category.type
        milestone.categorySrc = category.src()
        const obj = {
          categoryType: category.type,
          categorySrc: category.src(),
          milestone: milestone,
        }
        data.push(obj)
      })
    })
    return data
  }

  private async getCategories(isShowModel = true): Promise<void> {
    const params: BabyFilter = new BabyFilter({
      babyId: this.babyId
    })

    this.isGetCategoryLoading = true
    const data = await CategoryService.list(params).catch(() => [])
    this.isGetCategoryLoading = false

    this.categories = data.categories
    this.cardData = this.getCardData(data.categories)
    this.data = this.cardData.slice(0, 3)
    this.cardData.splice(0, 3)

    this.milestonesMemo = data.milestonesMemo
    if (isShowModel)
      this.showMilestoneModel()
  }

  private loadMore(e: any) {
    if (this.cardData.length == 0) return
    let {scrollTop, clientHeight, scrollHeight} = e.target
    if (scrollTop + clientHeight >= scrollHeight * 4 / 5) {
      this.data.push(this.cardData[0])
      this.cardData.splice(0, 1)
    }
  }

  private showMilestoneModel(): any {
    if (this.milestonesMemo.length == 0) return this.modelMilestoneMemo = false
    this.modelMilestoneMemo = true
    this.milestoneMemo = this.milestonesMemo[0].milestoneMemo
  }

  private async closeMilestoneMemo(): Promise<void> {
    const payload: MilestoneDto = new MilestoneDto({
      milestoneId: this.milestonesMemo[0].id
    })

    const response = await BabyService.readMilestone(this.babyId, payload).catch(() => false)
    if (response.hasError) return

    this.milestonesMemo.splice(0, 1)
    this.showMilestoneModel()
  }

  get iconDropdown(): string {
    if (this.isOpen) return 'chevron-up-small'
    return 'chevron-down-small'
  }

  private async clearMilestone(milestone: MilestoneInterface): Promise<void> {
    let payload = new FormData();
    payload.append('milestoneId', milestone.id.toString());
    payload.append("file", this.imageFile);

    this.isUploadFileLoading = true
    const response = await BabyService.milestoneClear(this.babyId, payload).catch(() => [])
    this.isUploadFileLoading = false

    if (response.hasError) return this.clearImage()

    this.modalVisible = false
    this.clearImage()
    await this.getBabies()
    await this.getCategories(false)
    this.memos = response
    this.showMemoModel()
  }

  private showMemoModel(): any {
    if (this.memos.length == 0) return this.modelMemo = false
    this.modelMemo = true
    const memo = this.memos[0]
    this.memo = memo.memo
    if (memo.typeMemo == TYPE_MEMO.MILESTONE_MEMO) {
      this.memoSrc = MEMO_SRC.MILESTONE
    } else {
      this.memoSrc = MEMO_SRC.STEP
    }
  }

  private handleImageChoose(e: any) {
    // this.isLoadingUpload = true

    const file = e.target.files[0];
    this.errorFile = ''
    if (file !== undefined) {
      if (file.name.lastIndexOf('.') <= 0) {
        return
      }
      const size = file.size / 1000000
      if (size > UPLOAD_MAX_SIZE) {
        this.errorFile = i18n.tc('validation.max_file_size', 0, {max: `${UPLOAD_MAX_SIZE}MB`})

        return this.clearImage()
      }

      this.imageFile = file
      let theReader = new FileReader();
      theReader.onload = () => {
        this.imageFileUrl = theReader.result
      };
      theReader.readAsDataURL(file);

    } else {
      this.clearImage();
    }
  }

  private clearImage() {
    this.imageFile = '';
    this.imageFileUrl = '';
  }

  private closeStepMemo(): any {
    this.memos.splice(0, 1)
    this.showMemoModel()
  }

  private closeModalUpload(): any {
    this.modalVisible = false
    this.clearImage()
  }

  private closeModalConfirm(): any {
    this.modalConfirm = false
  }

  private showUploadModal(): void {
    this.modalConfirm = false
    this.type = this.milestone.type
    this.modalVisible = true
    this.actionFireWork();

    this.congratulationText = this.milestone.comment
  }

  private showConfirmModal(data: EventBusUploadModalType): void {
    this.errorFile = ''
    const {milestone} = data
    this.milestone = milestone
    this.modalConfirm = true
  }

  private actionFireWork() {
    var myCanvas = document.getElementById("canvas-fire-work");
    var myConfetti = confetti.create(myCanvas, {
      resize: true,
      useWorker: true
    });
    setTimeout(function () {
      myConfetti({
        particleCount: 300,
        spread: 70,
        zIndex: 1050
      });
    }, 500)
  }

  private hideModalVisible(): void {
    this.clearImage()
  }

  private onClickAlbumLink(): any {
    return this.$router.push({name: 'routes.album', params: {id: this.babyId}})
  }

  private onClickSalonLink(): void {
    const url = 'https://www.online.bokuno-h.com/salon'
    window.open(url, '_blank');
  }
}
